'use strict'

module.exports = '/spdy/3.1.0'



//////////////////
// WEBPACK FOOTER
// ./~/libp2p-spdy/src/spdy-codec.js
// module id = 257
// module chunks = 0